"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeatmapTooltipContent = HeatmapTooltipContent;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _ChartsTooltip = require("@mui/x-charts/ChartsTooltip");
var _hooks = require("@mui/x-charts/hooks");
var _internals = require("@mui/x-charts/internals");
var _useHeatmapSeries = require("../../hooks/useHeatmapSeries");
var _HeatmapTooltipAxesValue = require("./HeatmapTooltipAxesValue");
var _HeatmapTooltip = require("./HeatmapTooltip.classes");
var _jsxRuntime = require("react/jsx-runtime");
function HeatmapTooltipContent(props) {
  const classes = (0, _HeatmapTooltip.useUtilityClasses)(props);
  const xAxis = (0, _hooks.useXAxis)();
  const yAxis = (0, _hooks.useYAxis)();
  const heatmapSeries = (0, _useHeatmapSeries.useHeatmapSeriesContext)();
  const tooltipData = (0, _ChartsTooltip.useItemTooltip)();
  if (!tooltipData || !heatmapSeries || heatmapSeries.seriesOrder.length === 0) {
    return null;
  }
  const {
    series,
    seriesOrder
  } = heatmapSeries;
  const seriesId = seriesOrder[0];
  const {
    color,
    value,
    identifier,
    markType
  } = tooltipData;
  const [xIndex, yIndex] = value;
  const formattedX = xAxis.valueFormatter?.(xAxis.data[xIndex], {
    location: 'tooltip',
    scale: xAxis.scale
  }) ?? xAxis.data[xIndex].toLocaleString();
  const formattedY = yAxis.valueFormatter?.(yAxis.data[yIndex], {
    location: 'tooltip',
    scale: yAxis.scale
  }) ?? yAxis.data[yIndex].toLocaleString();
  const formattedValue = series[seriesId].valueFormatter(value, {
    dataIndex: identifier.dataIndex
  });
  const seriesLabel = (0, _internals.getLabel)(series[seriesId].label, 'tooltip');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartsTooltip.ChartsTooltipPaper, {
    className: classes.paper,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ChartsTooltip.ChartsTooltipTable, {
      className: classes.table,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_HeatmapTooltipAxesValue.HeatmapTooltipAxesValue, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: formattedX
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: formattedY
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ChartsTooltip.ChartsTooltipRow, {
          className: classes.row,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_ChartsTooltip.ChartsTooltipCell, {
            className: (0, _clsx.default)(classes.labelCell, classes.cell),
            component: "th",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: classes.markContainer,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_internals.ChartsLabelMark, {
                type: markType,
                color: color,
                className: classes.mark
              })
            }), seriesLabel]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartsTooltip.ChartsTooltipCell, {
            className: (0, _clsx.default)(classes.valueCell, classes.cell),
            component: "td",
            children: formattedValue
          })]
        })
      })]
    })
  });
}
process.env.NODE_ENV !== "production" ? HeatmapTooltipContent.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object
} : void 0;